import React, { useEffect, useRef } from 'react';
import { useStore } from '@thd-nucleus/experience-context';
import { useLazyDataModel } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';

export const useQuoteProduct = ({
  projectStoreId,
  projectZipCode,
  loadedProductsData,
  updateLoadedProductsData,
  setQuoteProductPage
}) => {
  const { storeId } = useStore();
  const { svocID } = useThdCustomer() || {};
  const itemBeingFetched = useRef({});

  const [fetchData, productResponse] = useLazyDataModel('quoteProduct', {
    variables: {
      accountId: svocID,
      store: projectStoreId || storeId,
      deliveryAddress: {
        zipCode: projectZipCode
      }
    }
  });

  const { data: qcProductsInfoData, error } = productResponse || {};

  const fetchNonSharedQcProductData = (item) => {
    const {
      quantity, sku, itemId, bridgeSolution, id
    } = item;
    const { optionKey, qcId } = bridgeSolution;
    const qcContextData = loadedProductsData.find((product) => product?.key === id);

    if (bridgeSolution && !qcContextData) {
      itemBeingFetched.current = id;
      fetchData({
        variables: {
          itemDetail: {
            omsId: itemId,
            sku,
            optionKey,
            quantity,
            qcId
          }
        }
      });
    }
  };

  useEffect(() => {
    const price = qcProductsInfoData?.quoteProduct?.pricing;
    const product = qcProductsInfoData?.quoteProduct?.product;
    if (qcProductsInfoData && itemBeingFetched.current) {
      const currentId = itemBeingFetched.current;
      if (updateLoadedProductsData) {
        updateLoadedProductsData({ product, price }, currentId);
      }
      setQuoteProductPage((prevPage) => prevPage + 1);
    }
  }, [qcProductsInfoData]);

  return { fetchNonSharedQcProductData, qcProductsInfoData };
};